import { defineStore } from "pinia";

export const usePlayerStore  = defineStore("usePlayerStore", {
    state: () => {
        return {
            players:[

            ],
            hopeAvailable: false,
        }
    },
    getters:{
        getPlayerById: (state) => {
            return (playerId) => state.players.find((player,index) => index === playerId)
        }
    },
    
    actions:{


        checkAllHope(){
            if(!this.hopeAvailable) this.hopeAvailable = true;
        },
        addPlayer(){
            this.players.push(
                {
                    characterName: "",
                    description:"",
                    stackOrder: ['Virtue', 'Vice', 'Hope'],
                    virtue: "",
                    vice:"",
                    hope:"",
                    brink:"",
                    stackIndex:0,
                    hasHope: false, 
                }
            )
        },
        deletePlayer(id){
            console.log(this.players[id])
            this.players.splice(id, 1);
        },
    },
    
});

/**
 *                 {
                    characterName: "Jared Crost",
                    description:"eiogoegih  eogihergo eegheog ",
                    stackOrder: ['Virtue', 'Vice', 'Hope'],
                    virtue: "Friendly",
                    vice:"Arrogant",
                    hope:"I will find hope when I find food",
                    brink:"I have seen you steal",
                    stackIndex:0,
                    hasHope: false,
                    isDead: false

                },
                {
                    characterName: "Krista Espinosa",
                    description:"eiogoegih  eogihergo eegheog ",
                    stackOrder: ['Vice', 'Hope', 'Virtue'],
                    virtue: "Brave",
                    vice:"Ignorant",
                    hope:"I will find hope when I find food",
                    brink:"I have seen you steal",
                    stackIndex:0,
                    hasHope: false,
                    isDead: false,
                },
 * 
 */